// =============================================
// Sumber Jurnal — warna & label badge (dipakai
// oleh Jurnal Umum & Dashboard Akuntansi)
// =============================================
export const SUMBER_JURNAL = {
  Manual:      { bg: '#f3f4f6', color: '#374151', label: 'Manual' },
  Tagihan:     { bg: '#dbeafe', color: '#1e40af', label: 'Tagihan' },
  Pembelian:   { bg: '#d1fae5', color: '#065f46', label: 'Pembelian' },
  Penerimaan:  { bg: '#ede9fe', color: '#5b21b6', label: 'Penerimaan' },
  Retur:       { bg: '#fef3c7', color: '#92400e', label: 'Retur' },
  Gaji:        { bg: '#fce7f3', color: '#9d174d', label: 'Gaji' },
  Penggajian:  { bg: '#fce7f3', color: '#9d174d', label: 'Penggajian' },
  'Lain-lain': { bg: '#f1f5f9', color: '#475569', label: 'Lain-lain' },
};

export function sumberInfo(sumber) {
  return SUMBER_JURNAL[sumber] || { bg: '#f1f5f9', color: '#475569', label: sumber || '-' };
}

export function badgeSumber(sumber) {
  const s = sumberInfo(sumber);
  return { background: s.bg, color: s.color };
}